<template>
  <div style="height: 100%">
    <div style="height: 10px"></div>
    <div style="height: 30px;margin: 0 30px">
      <img style="vertical-align: bottom" v-if="deviceRow.sleep_inbed === 1" src="/static/health/icon_bed.png">
      <img style="vertical-align: bottom" v-if="deviceRow.sleep_inbed === 0" src="/static/health/icon_leave_bed.png">
      <span style="color: #cccccc;font-size: 18px;vertical-align: super;">在床状态</span>
    </div>
    <div style="height: 20px;"></div>
    <div style="height: calc(100% - 100px)" id="inBed" ref="bar_warp1"></div>
  </div>
</template>

<script>
export default {
  name: 'inBed',
  props: {
    deviceRow: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      xData: [],
      yData: []
    }
  },
  created () {
  },
  mounted () {
    this.initCharts()
    this.isShow = true
  },
  methods: {
    getStartData (arr) {
      for (let i = 0; i < arr.length; i++) {
        this.xData.push(arr[i].time)
        this.yData.push(arr[i].inbed)
      }
      if (this.isShow) {
        this.initCharts()
      }
    },
    initCharts () {
      let chart = this.$echarts.init(this.$refs.bar_warp1)
      chart.setOption({
        color: ['#3398DB'],
        tooltip: {
          trigger: 'axis',
          axisPointer: { // 坐标轴指示器，坐标轴触发有效
            type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
          },
          formatter: function (params) {
            return params[0].name + '<br>' + (params[0].value === 0 ? '离床' : '在床')
          }
        },
        grid: {
          top: '13%',
          left: '4%',
          right: '4%',
          bottom: '20%',
          containLabel: true
        },
        xAxis: [
          {
            type: 'category',
            data: this.xData,
            axisLine: {
              lineStyle: {
                color: '#7fd4ff',
                width: 1
              }
            },
            axisPointer: {
              type: 'shadow'
            }
          }
        ],
        yAxis: [
          {
            type: 'value',
            axisLine: {
              show: false
            },
            name: '',
            min: 0,
            axisLabel: {
              show: false,
              formatter: '{value}'
            },
            splitLine: {
              show: false,
              lineStyle: {
                color: '#182f4d',
                width: 1 // 这里是为了突出显示加上的
              }
            }
          }
        ],
        series: [
          {
            name: '状态',
            type: 'bar',
            barWidth: 10,
            data: this.yData
          }
        ]
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/datamanagement/healthComponents/inBed.vue